module.exports = __webpack_public_path__ + "img/buffalo-rock-logo.4ab4f055.jpg";